import { api } from "..";

export interface GetOddsAdjustmentsParams {
  matchId: number;
  providerId: number;
  feedType: string;
  targetUsername?: string;
  lang?: string;
}

export interface OddsAdjustmentMap {
  [selectionKey: string]: {
    adjustmentValue: number;
    active?: boolean;
  };
}

export interface GetOddsAdjustmentsResponse {
  sportEvent: any;
  adjustments: OddsAdjustmentMap;
}

export async function getOddsAdjustments(
  params: GetOddsAdjustmentsParams
): Promise<GetOddsAdjustmentsResponse> {
  const res = await api.client.get(
    `/sport-events-new/odds-adjustment/${params.matchId}`,
    {
      params: {
        providerId: params.providerId,
        feedType: params.feedType,
        targetUsername: params.targetUsername,
        lang: params.lang ?? "en",
      },
    }
  );
  return res.data;
}
